import { Stack, Button, Grid, Dialog, Typography, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import updateOrder from "../../../../api/public/storefronts/orders/update";
import useCheckoutStore from '../../../../stores/public/useCheckoutStore';
import useStorefrontStore from '../../../../stores/public/useStorefrontStore';
import updateOrderApi from '../../../../api/public/storefronts/orders/update';
import update from '../../../../api/public/storefronts/locations/update';
import create from '../../../../api/public/storefronts/locations/create';
import WushTextField from '../../../form/WushTextField';
import WushStateSelect from '../../../form/WushStateSelect';
import useYupValidationResolver from '../../../../services/useYupValidationResolver';
import checkExisting from '../../../../api/public/storefronts/locations/checkExisting';
import { useEffect, useState } from 'react';
import WushCard from '../../../layout/WushCard';

const validationSchema = yup.object({
  address_1: yup.string().required("Required"),
  city: yup.string().required("Required"),
  state: yup.string().required("Required"),
  zip: yup.string().required("Required")
});

export default function DeliveryInformation({ customerCanPickup, previousStep, nextStep}) {
  const [ matchingLocations, setMatchingLocations ] = useState([]);
  const [ showMatchingLocations, setShowMatchingLocations ] = useState(false);
  const [ isSelfPickup, setIsSelfPickup ] = useState(false);

  const { organization } = useStorefrontStore();

  const { location, setLocation, order, setOrder } = useCheckoutStore();

  const resolver = useYupValidationResolver(validationSchema);

  const { handleSubmit, register, formState } = useForm({
    resolver: !isSelfPickup && resolver,
    defaultValues: location,
    reValidateMode: 'onSubmit'
  });

  const createLocation = (values) => {
    create(organization.id, values, (response) => {
      updateOrder(organization.id, order.id, {
        location_id: response.id
      }, (response) => {
        console.log(response);
        setOrder(response);
        nextStep();
      });
      setLocation(response);
    });
  };

  const handleMatchLocation = (location) => {
    updateOrder(organization.id, order.id, {
      location_id: location.id
    }, (response) => {
      console.log(response);
      setOrder(response);
      nextStep();
    });
    setLocation(location);
    setShowMatchingLocations(false);
  };

  const onSubmit = (values) => {
    if(isSelfPickup) {
      return;
    }
    if(location?.id) {
      update(organization.id, location.id, values, (response) => {
        updateOrder(organization.id, order.id, {
          location_id: response.id
        }, (response) => {
          setOrder(response);
        });
        setLocation(response);
      });
    } else {
      checkExisting(organization.id, values, (response) => {
        if(response.length > 0) {
          setMatchingLocations(response);
          setShowMatchingLocations(true);
        } else {
          create(organization.id, values, (response) => {
            updateOrder(organization.id, order.id, {
              location_id: response.id
            }, (response) => {
              setOrder(response);
            });
            setLocation(response);
          });
        }
      });
    }
  };

  useEffect(() => {
    updateOrderApi(organization.id, order.id, { checkout_status: 'delivery_information' });
  }, []);

  return (
    <Stack>
      {
        location ? <WushCard bgcolor={"#ffffff"}>
          <Stack p={2}>
            <Stack mb={1}>
              <Typography variant="h4" sx={{ my: "auto" }}>
                {location.name}
              </Typography>
              <Typography variant="h5" sx={{ my: "auto" }}>
                {location.address_1}, {location.city}, {location.state} {location.zip}
              </Typography>
            </Stack>
            <Stack direction="row">
              <Button variant="outlined" onClick={() => setLocation(null)}>Edit</Button>
            </Stack>
          </Stack>
        </WushCard> :
        <form onSubmit={handleSubmit(onSubmit)}>
          <WushCard bgcolor={"#ffffff"}>
            <Stack p={2}>
              <Stack gap={1} mb={1}>
                {customerCanPickup && <Stack direction="row">
                  <Checkbox
                    checked={isSelfPickup}
                    onChange={(e) => {
                      setIsSelfPickup(e.target.checked);
                      e.target.checked ? nextStep() : previousStep();
                    }}
                  />
                  <Typography sx={{ my: "auto" }} variant="body1">I will pick these items up myself or call later to setup delivery</Typography>
                </Stack>}
                {!isSelfPickup && <Stack>
                  <Stack mb={1}>
                    <Typography variant="body1">Please enter the delivery address for your reservation</Typography>
                  </Stack>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Stack>
                        <WushTextField formRegistration={register('address_1')} formState={formState} label="Address 1" defaultValue={location?.address_1} />
                      </Stack>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack>
                        <WushTextField formRegistration={register('address_2')} formState={formState} label="Address 2" defaultValue={location?.address_2} />
                      </Stack>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack>
                        <WushTextField formRegistration={register('city')} formState={formState} label="City" defaultValue={location?.city} />
                      </Stack>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack>
                        <WushStateSelect formRegistration={register('state')} formState={formState} label="State" defaultValue={location?.state} />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}sm={6}>
                      <Stack>
                        <WushTextField formRegistration={register('zip')} formState={formState} label="Zip" defaultValue={location?.zip} />
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>}
              </Stack>
              <Stack direction="row" width="100%" justifyContent="right">
                <Button width="500px" size="large" variant="contained" onClick={handleSubmit(onSubmit)}>Continue</Button>
              </Stack>
            </Stack>
          </WushCard>
          <Dialog
            open={showMatchingLocations}
            onClose={() => setShowMatchingLocations(false)}
          >
            <Stack p={2}>
              <Stack mb={2}>
                <Typography variant="h4">Are any of these your address?</Typography>
              </Stack>
              <Stack>
                {matchingLocations.map((location) => (
                  <WushCard mb={1} key={location.id} onClick={() => handleMatchLocation(location)}>
                    <Stack p={2} key={location.id}>
                      <Typography variant="body1" sx={{ my: "auto" }}>
                        {location.name}
                      </Typography>
                      <Typography variant="body1" sx={{ my: "auto" }}>
                        {location.address_1}, {location.city}, {location.state} {location.zip}
                      </Typography>
                    </Stack>
                  </WushCard>
                ))}
                <WushCard onClick={handleSubmit(createLocation)}>
                  <Stack p={2}>
                    <Typography variant="body1" sx={{ my: "auto" }} fontWeight="700">
                      None of these
                    </Typography>
                  </Stack>
                </WushCard>
              </Stack>
            </Stack>
          </Dialog>
        </form>
      }
    </Stack>
  );
}